import { create } from "zustand"
import type { UserResponse } from "@/shared/types/api"

interface AuthState {
  user: UserResponse | null
  isAuthenticated: boolean
  isLoading: boolean
  setAuth: (user: UserResponse) => void
  clearAuth: () => void
  initAuth: () => Promise<void>
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,

  setAuth: (user) => {
    set({ user, isAuthenticated: true, isLoading: false })
  },

  clearAuth: () => {
    set({ user: null, isAuthenticated: false, isLoading: false })
  },

  initAuth: async () => {
    try {
      // Fetch user profile from backend using cookie auth
      // Skip global error toast since 401 is expected on login page
      const { authApi } = await import("../api/authApi")
      const user = await authApi.getProfile(true)
      set({ user, isAuthenticated: true, isLoading: false })
    } catch {
      // No valid session, user is not authenticated
      // This is expected on login/signup pages, so we silently fail
      set({ user: null, isAuthenticated: false, isLoading: false })
    }
  },
}))
